import { combineReducers } from "redux";
import all_booking from "../features/admin/booking/all_booking/slice";

const bookingmanagement = combineReducers({
  all_booking: all_booking,
});

export default bookingmanagement;
